import { Apartment, Group, Settings } from '@mui/icons-material';
import { Route } from 'src/types/interfaces/route';

import { Calendar as CalendarIcon } from '../icons/calendar';
import { CustomUsers as UsersIcon } from '../icons/custom-users';
import { ExclamationOutlined as AlertIcon } from '../icons/exclamation-outlined';
import { OfficeBuilding as OfficeBuildingIcon } from '../icons/office-building';
import { User as UserIcon } from '../icons/user';

export enum RouteTitle {
  VISITS = 'visits:titleVisitors',
  CREATE_VISIT = 'createVisit:title',
  HOSTS = 'hosts:title',
  BILLING_GROUPS = 'billingGroups:title',
  DESTINATION_GROUPS = 'destinationGroups:title',
  DESTINATIONS = 'destinations:title',
  ACCESS_CONTROL_EVENTS = 'accessControlEvents:title',
  ORGANIZATION_ADMINS = 'organizationAdmins:title',
  SETTINGS = 'settings:title',
}

export const getRoutes = (): Route[] => [
  { icon: UsersIcon, title: RouteTitle.VISITS, href: '/visits' },
  { icon: CalendarIcon, title: RouteTitle.CREATE_VISIT, href: '/visits/create' },
  { icon: UserIcon, title: RouteTitle.HOSTS, href: '/hosts' },
  { icon: Group, title: RouteTitle.BILLING_GROUPS, href: '/billing-groups' },
  { icon: Apartment, title: RouteTitle.DESTINATION_GROUPS, href: '/destination-groups' },
  { icon: OfficeBuildingIcon, title: RouteTitle.DESTINATIONS, href: '/destinations' },
  { icon: AlertIcon, title: RouteTitle.ACCESS_CONTROL_EVENTS, href: '/access-control-events' },
  { icon: UsersIcon, title: RouteTitle.ORGANIZATION_ADMINS, href: '/organization-admins' },
  { icon: Settings, title: RouteTitle.SETTINGS, href: '/settings/gdpr' },
];
